export default __webpack_public_path__ + "static/media/flutter-icon.cbd9467e.svg";